import { TLanguages } from "~/lang/types/languages"

export const languages: TLanguages = {
  fa: "فارسی",
  en: "انگلیسی",
  dashboards: "داشبورد",
  basicInformation: "اطلاعات پایه",
  cargoManagement: "مدیریت بار ها",
  cargoOwnerManagement: "مدیریت صاحبان بار",
  driverManagement: "مدیریت رانندگان",
  shippingManagement: "مدیریت حمل ها",
  loadsManagement: "مدیریت بارها",
  bol: "بارنامه ها",
  otpManagement: "مدیریت OTP",
  loadingManagement: "مدیریت بارگیری",
  users: "کاربران",
  contractManagement: {
    title: "مدیریت قرارداد",
    subHangouts: {
      cargoOwner: "قرارداد با صاحب بار",
      bolCompany: "قرارداد با شرکت صدور بارنامه",
    },
  },
  financialManagement: {
    title: "مدیریت مالی",
    subHangouts: {
      withdrawal: "درخواست برداشت وجه",
      freightFinancialReport: "گزارشات مالی",
    },
  },
  financial: "مالی و حساب داری",
  reports: "گزارشات",
  profile: "پروفایل",
  settings: "تنظیمات",
  logout: "خروج",
  description: "توضیحات",
  fullscreen: "نمایش تمام صفحه",
  exitFullscreen: "خروج از تمام صفحه",
  phoneNumber: "شماره تماس",
  brand: "برند",
  billOfLading: "بارنامه",
  smartDriverCode: "کد هوشمند راننده",
  model: "مدل",
  constructionYear: "سال ساخت",
  licenceNumber: "شماره گواهینامه",
  nationalCode: "کد ملی",
  smartNumber: "شماره هوشمند",
  remittanceIssuance: "صدور حواله",
}
